import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["periodSelect", "startDate", "endDate"]

  selectPeriod(event) {
    const select = event.target
    const selectedOption = select.options[select.selectedIndex]

    if (selectedOption.value === "") {
      // Custom range selected, don't change the date inputs
      return
    }

    const startDate = selectedOption.dataset.start
    const endDate = selectedOption.dataset.end

    if (startDate && endDate) {
      this.startDateTarget.value = startDate
      this.endDateTarget.value = endDate
    }
  }
}
